/* eslint-disable @typescript-eslint/ban-ts-comment */
import React from 'react'
import cx from 'classnames'
import { useTranslation } from 'react-i18next'
import { SortOptions } from '../../constants/enums'

export interface IBreadCrumbs extends React.HTMLAttributes<HTMLDivElement> {
  className?: string
  onClickMap: () => void
  onClickList: () => void
  onChangeSort: (value: SortOptions) => void
  sortValue: string
  selectedOption: 'map' | 'list'
}

const BreadCrumbs = function ({
  className,
  sortValue,
  onChangeSort,
  onClickList,
  onClickMap,
  selectedOption,
  ...props
}: IBreadCrumbs) {
  const { t } = useTranslation()

  const sortOptions = [
    {
      value: 'wildcard',
      label: t('filters.sortBy'),
    },
    {
      value: 'az',
      label: 'A - Z',
    },
    {
      value: 'neighborhood',
      label: t('filters.neigborhood'),
    },
  ]

  return (
    <div className={cx(className, 'ocla-breadcrumbs')} {...props}>
      <div
        className={cx({
          'ocla-breadcrumbs__selected-item': selectedOption === 'list',
          'ocla-breadcrumbs__item': selectedOption === 'map',
        })}
        onClick={onClickList}
      >
        {t('filters.list')}
      </div>
      <div
        className={cx({
          'ocla-breadcrumbs__selected-item': selectedOption === 'map',
          'ocla-breadcrumbs__item': selectedOption === 'list',
        })}
        onClick={onClickMap}
      >
        {t('filters.map')}
      </div>
      <select
        value={sortValue}
        onChange={(e) => {
          // @ts-ignore
          onChangeSort(e.target.value)
        }}
      >
        {sortOptions.map((option) => {
          return (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          )
        })}
      </select>
    </div>
  )
}

export default React.memo(BreadCrumbs)
